export function toggleArrayItem(arr, item) {
  return arr.includes(item) ? arr.filter((i) => i !== item) : [...arr, item];
}

export const convertToObject = (array, headers) => {
  const headersIndexToHeaderMapping = headers.reduce((acc, headerKey) => {
    acc[headers.indexOf(headerKey)] = headerKey;
    return acc;
  }, {});
  return array.reduce((acc, value, index) => {
    acc[headersIndexToHeaderMapping[index]] = value;
    return acc;
  }, {});
};
